import { render, staticRenderFns } from "./IdentifyUploadSuccess.vue?vue&type=template&id=7d24a82a&scoped=true"
import script from "./IdentifyUploadSuccess.vue?vue&type=script&lang=js"
export * from "./IdentifyUploadSuccess.vue?vue&type=script&lang=js"
import style0 from "./IdentifyUploadSuccess.vue?vue&type=style&index=0&id=7d24a82a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d24a82a",
  null
  
)

export default component.exports